
import { gsap } from "gsap";
import g from "../globals/variables";

const Numbers = (target) => {

  const el = {
    numbers: target.querySelectorAll("[data-type=\"number\"], [data-type=\"percentage\"]") as NodeListOf<HTMLElement>,
  };

  const method = {

    init: () => {
      if (g.scroll) {
        g.scroll.on("call", (event) => {
          if (event === "countup") method.countUp();
        });
      }
    },

    countUp: () => {
      el.numbers.forEach((number, index) => {
        const nrEl = number;

        const counter = {
          nr: Number(nrEl.innerText) / 2,
          to: Number(nrEl.innerText),
        };

        gsap.to(counter, {
          delay: (index + 1) * 0.25,
          duration: 3 + index / 4,
          ease: "power4.out",
          nr: counter.to,
          onUpdate: () => {
            nrEl.innerText = counter.nr.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
          },
          roundProps: "nr",
        });
      });
    },
  };

  method.init();
};

export default Numbers;
